import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import { onBeforeMount, ref } from 'vue';
import { Permission, usePermission } from '@/modules/user/Permission';
import { UserType } from '@/modules/user/User';
import { Flash } from '@/core/Flash';
import AppFormGroup from '@/core/components/form/AppFormGroup.vue';
import AppCheck from '@/core/components/form/AppCheck.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserPermissions',
  props: {
    modelValue: {},
    userType: {}
  },
  emits: [
	'update:modelValue',
],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const permissions = ref<Permission[]>();

const loadData = async () => {
	return usePermission(props.userType)
		.then(r => {
			permissions.value = r;
		})
		.catch(err => Flash.danger(err.message, 'Kunde inte hämta data', 20000))
	;
};

onBeforeMount(loadData);

const hasPermission = (p): boolean => {
	return props.modelValue?.indexOf(p) >= 0;
};

const select = (perm: string, selected: boolean) => {
	let permissions = props.modelValue;
	if (selected) {
		permissions.push(perm);
	} else {
		permissions = permissions.filter(p => p !== perm);
	}

	emit('update:modelValue', permissions);
};

return (_ctx: any,_cache: any) => {
  return (permissions.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(permissions.value, (name, permission) => {
          return (_openBlock(), _createBlock(AppFormGroup, {
            key: permission,
            id: 'permission_' + permission,
            label: name
          }, {
            before: _withCtx(() => [
              _createVNode(AppCheck, {
                id: 'permission_' + permission,
                "model-value": hasPermission(permission),
                "onUpdate:modelValue": ($event: any) => (select(permission, $event))
              }, null, 8, ["id", "model-value", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1032, ["id", "label"]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})